import { render, staticRenderFns } from "./RecommendationLibrary.vue?vue&type=template&id=4aa493f8&"
import script from "./RecommendationLibrary.vue?vue&type=script&lang=js&"
export * from "./RecommendationLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports